import React from "react";

function RabbitForm({ additionalAttributes, setAdditionalAttributes }) {
  const handleChange = (e) => {
    setAdditionalAttributes({
      ...additionalAttributes,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="rabbitForm">
      {/* Dovşan növü */}
      <div>
        <h3>Dovşan növü <span>*</span></h3>
        <select name="rabbitType" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Ev dovşanı">Ev dovşanı</option>
          <option value="Holland Lop">Holland Lop</option>
          <option value="Angora">Angora</option>
          <option value="Mini Rex">Mini Rex</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

      {/* Yaş */}
      <div>
        <h3>Yaş <span>*</span></h3>
        <input type="number" name="age" min="0" max="10" required placeholder="Yaşı (illərlə)" onChange={handleChange} />
      </div>

      {/* Cins */}
      <div>
        <h3>Cins <span>*</span></h3>
        <select name="gender" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Erkək">Erkək</option>
          <option value="Dişi">Dişi</option>
          <option value="Naməlum">Naməlum</option>
        </select>
      </div>

      {/* Rəng */}
      <div>
        <h3>Rəng <span>*</span></h3>
        <input type="text" name="color" required placeholder="Rəngi daxil edin" onChange={handleChange} />
      </div>

      {/* Çəki */}
      <div>
        <h3>Çəki (kg) <span>*</span></h3>
        <input type="number" name="weight" min="0.1" max="10" step="0.1" required placeholder="Çəkini daxil edin" onChange={handleChange} />
      </div>

      {/* Sağlamlıq vəziyyəti */}
      <div>
        <h3>Sağlamlıq vəziyyəti <span>*</span></h3>
        <select name="healthStatus" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Sağlam">Sağlam</option>
          <option value="Müalicə olunmuş">Müalicə olunmuş</option>
          <option value="Xəstə">Xəstə</option>
        </select>
      </div>

      {/* Qəfəs daxildirmi? */}
      <div>
        <h3>Qəfəs daxildirmi? <span>*</span></h3>
        <select name="includesCage" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

    </div>
  );
}

export default RabbitForm;
